module.exports = __webpack_public_path__ + "img/minimize-map.34bfae85.svg";